import React from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import { EntitiesSection } from './SelectedEntities/styled'
import SelectedEntity from './SelectedEntities/SelectedEntity'

const SelectedEntities = ({
  selectedEntities,
  onClick,
  onRemove,
  isFacility,
  loading
}) => (
  <Spin spinning={loading}>
    <EntitiesSection>
      {selectedEntities.length ? (
        selectedEntities.map(entity => (
          <SelectedEntity
            entity={entity}
            isFacility={isFacility}
            key={entity.id}
            onClick={onClick}
            onRemove={onRemove}
          />
        ))
      ) : (
        <>Selected options will appear here</>
      )}
    </EntitiesSection>
  </Spin>
)

SelectedEntities.propTypes = {
  selectedEntities: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  isFacility: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired
}

export default SelectedEntities
